// import React, { useEffect, useState } from "react";
// import { image_ip, test_ip } from "../services/constants";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Alert } from "@mui/material";
// import { check_error_code } from "../services/error_string";
// import Loading from "../components/Loading";
// const SelectVehicle = () => {
//   const [pickupCoordinates, setPickupCoordinates] = useState(null);
//   const [dropoffCoordinates, setDropoffCoordinates] = useState(null);
//   const [error, setError] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [distance, setDistance] = useState(0);
//   const [vehicles, setVehicles] = useState([]);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);
//   const [itemQuantity, setItemQuantity] = useState(1);
//   const [roundTrip, setRoundTrip] = useState(false);
//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));

//   const calculateDistance = (pickupCoordinates, dropoffCoordinates) => {
//     const R = 6371; // Radius of the Earth in kilometers

//     const toRadians = (degrees) => degrees * (Math.PI / 180);

//     const lat1 = toRadians(pickupCoordinates.lat);
//     const lng1 = toRadians(pickupCoordinates.lng);
//     const lat2 = toRadians(dropoffCoordinates.lat);
//     const lng2 = toRadians(dropoffCoordinates.lng);

//     const deltaLat = lat2 - lat1;
//     const deltaLng = lng2 - lng1;

//     const a =
//       Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
//       Math.cos(lat1) *
//         Math.cos(lat2) *
//         Math.sin(deltaLng / 2) *
//         Math.sin(deltaLng / 2);

//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//     const distance = R * c * 1000; // Distance in kilometers
//     return distance;
//   };

//   useEffect(() => {
//     const vehicleList = localStorage.getItem("vehicleList");
//     if (vehicleList) {
//       const parsedVehicleList = JSON.parse(vehicleList);
//       setVehicles(parsedVehicleList || []);
//     }
//     const storedPickup = JSON.parse(localStorage.getItem("pickupCoordinates"));
//     const storedDropoff = JSON.parse(
//       localStorage.getItem("dropoffCoordinates")
//     );

//     if (storedPickup && storedDropoff) {
//       setPickupCoordinates(storedPickup);
//       setDropoffCoordinates(storedDropoff);
//       const calculatedDistance = calculateDistance(storedPickup, storedDropoff);
//       setDistance(calculatedDistance);
//     }
//   }, []);

//   const handleSelectVehicle = (vehicle) => {
//     setSelectedVehicle(vehicle);
//     console.log("Selected vehicle:", vehicle);
//   };

//   const handleCheckout = async () => {
//     var message;
//     if (!itemQuantity) {
//       message = "Please Add Item Quantity.";
//     }
//     if (!selectedVehicle) {
//       message = "please select vehicle first";
//     }
//     setLoading(true);
//     // else if (receiverPhone.length !== 9) {
//     //   message = "Receiver Phone number must be exactly 9 digits long.";
//     // }
//     // If there's any message, set the error and return early
//     if (message) {
//       setError([message]);
//       setLoading(false);
//       return;
//     }
//     try {
//       const payload = {
//         city_id: "5b406b46d2ddf8062d11b788",
//         user_id: user.user_id,
//         is_round_trip: roundTrip,
//         total_item_count: itemQuantity,
//         is_user_drop_order: true,
//         is_user_pickup_order: false,
//         server_token: user.server_token,
//         vehicle_id: selectedVehicle._id,
//         total_distance: distance,
//         total_time: 120,
//         country_id: "5b3f76f2022985030cd3a437",
//       };
//       console.log(payload);
//       const response = await axios.post(
//         `${test_ip}api/user/get_courier_order_invoice`,
//         payload
//       );
//       if (response.data.success) {
//         localStorage.setItem(
//           "courier_op",
//           JSON.stringify(response.data.order_payment)
//         );
//         navigate("/courier/invocie");
//       } else {
//         var message = check_error_code(response.data.error_code);
//         setError([message]);
//       }
//     } catch (error) {
//       console.error("Error adding item to cart:", error);
//       setError(["something went wrong"]);
//       // Optionally, show an error message to the user
//     } finally {
//       setLoading(false); // Set loading to false when the API call is complete (whether success or error)
//     }
//     console.log("Proceeding to checkout with:", {
//       selectedVehicle,
//       itemQuantity,
//       roundTrip,
//     });
//   };

//   // ... other parts of the component

//   return (
//     <div style={styles.container}>
//       <div style={{ ...styles.innerContainer, width: "300px" }}>
//         <div style={styles.header}>
//           <h2>Select a Vehicle</h2>
//         </div>
//         {vehicles.length === 0 ? (
//           <p>No vehicles available.</p>
//         ) : (
//           <ul style={styles.vehicleList}>
//             {vehicles.map((vehicle) => (
//               <li
//                 key={vehicle._id}
//                 style={styles.vehicleItem}
//                 onClick={() => handleSelectVehicle(vehicle)}
//               >
//                 <div
//                   style={{
//                     ...styles.vehicleInfo,
//                     backgroundColor:
//                       selectedVehicle?._id === vehicle._id
//                         ? "#ff6347"
//                         : "white",
//                   }}
//                 >
//                   <img
//                     src={`${image_ip}${vehicle.image_url}`}
//                     alt={vehicle.vehicle_name}
//                     style={styles.vehicleImage}
//                   />
//                   <p
//                     style={{
//                       ...styles.vehicleName,
//                       color:
//                         selectedVehicle?._id === vehicle._id
//                           ? "white"
//                           : "black",
//                       marginTop: "5px",
//                     }}
//                   >
//                     {vehicle.vehicle_name}
//                   </p>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         )}
//         <div style={styles.itemQuantityContainer}>
//           <label htmlFor="item-quantity">Item Quantity:</label>
//           <input
//             type="number"
//             id="item-quantity"
//             value={itemQuantity}
//             onChange={(e) => setItemQuantity(e.target.value)}
//             style={styles.itemQuantityInput}
//           />
//         </div>

//         <div style={styles.roundTripContainer}>
//           <label style={styles.roundTripLabel}>Round Trip?</label>
//           <div style={styles.roundTripOptions}>
//             <label style={styles.radioLabel}>
//               <input
//                 type="radio"
//                 checked={roundTrip === true}
//                 onChange={() => setRoundTrip(true)}
//                 style={{
//                   ...styles.radioInput,
//                   ...(roundTrip === true ? styles.radioInputChecked : {}),
//                 }}
//               />
//               Yes
//             </label>
//             <label style={styles.radioLabel}>
//               <input
//                 type="radio"
//                 checked={roundTrip === false}
//                 onChange={() => setRoundTrip(false)}
//                 style={{
//                   ...styles.radioInput,
//                   ...(roundTrip === false ? styles.radioInputChecked : {}),
//                 }}
//               />
//               No
//             </label>
//           </div>
//         </div>
//         {/* {!error.length == 0 ? (
//           <Alert style={{ margin: "10px" }} severity="error">
//             {error[0]}
//           </Alert>
//         ) : null} */}
//         {loading ? (
//           <div style={{ display: "flex", justifyContent: "center" }}>
//             <Loading />
//           </div>
//         ) : (
//           <button
//             onClick={handleCheckout}
//             style={{
//               ...styles.checkoutButton,
//               width: "100%",
//               // opacity: selectedVehicle ? 1 : 0.6,
//               // cursor: selectedVehicle ? "pointer" : "not-allowed",
//               backgroundColor: "#ff6347",
//               padding: "10px 0",
//               marginTop: "10px",
//             }}
//           >
//             Checkout
//           </button>
//         )}

//         {!error.length == 0 ? (
//           <Alert style={{ margin: "10px" }} severity="error">
//             {error[0]}
//           </Alert>
//         ) : null}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: "20px",
//     backgroundColor: "#f5f5f5",
//     height: "100vh",
//   },
//   innerContainer: {
//     maxWidth: "300px",
//     margin: "0 auto",
//     backgroundColor: "white",
//     padding: "20px",
//     borderRadius: "10px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },

//   header: {
//     display: "flex",
//     justifyContent: "center", // Centers the content horizontally
//     alignItems: "center",
//     marginBottom: "20px",
//   },
//   backIcon: {
//     cursor: "pointer",
//     fontSize: "24px",
//     marginRight: "10px",
//   },
//   vehicleList: {
//     listStyleType: "none",
//     padding: "0",
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "start",
//   },
//   vehicleItem: {
//     marginBottom: "5px",
//     cursor: "pointer",
//     flex: "0 0 auto",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     marginRight: "5px",
//   },
//   vehicleInfo: {
//     borderRadius: "10px",
//     padding: "10px",
//     border: "1px solid #ccc",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "100px",
//     height: "100px",
//     marginBottom: "5px",
//     transition: "background-color 0.3s",
//     paddingLeft: "15px", // Increased left padding for the image
//     paddingRight: "15px", // Added right padding for symmetry
//     margin: "0 auto", // Center the vehicleInfo div
//   },
//   vehicleImage: {
//     width: "70px",
//     height: "70px",
//     borderRadius: "50%",
//   },
//   vehicleName: {
//     textAlign: "center",
//     fontWeight: "bold",
//     marginTop: "5px",
//   },
//   itemQuantityContainer: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: "10px",
//     padding: "0 10px",
//   },
//   itemQuantityInput: {
//     marginLeft: "5px",
//     width: "140px", // Increased width for the input
//     padding: "10px", // Increased padding for better usability
//     fontSize: "11px", // Optional: increase font size for better visibility
//   },

//   roundTripContainer: {
//     display: "flex",
//     flexDirection: "column", // Stack label and options vertically
//     marginBottom: "10px",
//     padding: "0 10px",
//   },
//   roundTripLabel: {
//     marginBottom: "5px", // Space between label and options
//   },
//   roundTripOptions: {
//     display: "flex",
//     flexDirection: "column", // Ensure options stack vertically
//   },
//   radioLabel: {
//     marginBottom: "5px", // Space between radio options
//     display: "flex",
//     alignItems: "center", // Align radio and text
//   },
//   radioInput: {
//     marginRight: "5px",
//     appearance: "none", // Remove default styling
//     width: "20px", // Size of the radio button
//     height: "20px",
//     border: "2px solid red", // Red border
//     borderRadius: "50%", // Round shape
//     outline: "none", // Remove outline
//     cursor: "pointer", // Pointer cursor on hover
//     position: "relative",
//   },
//   radioInputChecked: {
//     backgroundColor: "#ff6347", // Change background to red when checked
//   },
//   checkoutButton: {
//     backgroundColor: "#ff6347",
//     color: "white",
//     padding: "10px 0",
//     border: "none",
//     borderRadius: "5px",
//     fontSize: "16px",
//   },
// };

// export default SelectVehicle;
import React, { useEffect, useState } from "react";
import { image_ip, test_ip } from "../services/constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { check_error_code } from "../services/error_string";
import Loading from "../components/Loading";

const SelectVehicle = () => {
  const [pickupCoordinates, setPickupCoordinates] = useState(null);
  const [dropoffCoordinates, setDropoffCoordinates] = useState(null);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [distance, setDistance] = useState(0);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [itemQuantity, setItemQuantity] = useState(1);
  const [roundTrip, setRoundTrip] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const calculateDistance = (pickupCoordinates, dropoffCoordinates) => {
    const R = 6371; // Radius of the Earth in kilometers

    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const lat1 = toRadians(pickupCoordinates.lat);
    const lng1 = toRadians(pickupCoordinates.lng);
    const lat2 = toRadians(dropoffCoordinates.lat);
    const lng2 = toRadians(dropoffCoordinates.lng);

    const deltaLat = lat2 - lat1;
    const deltaLng = lng2 - lng1;

    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(deltaLng / 2) *
        Math.sin(deltaLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c * 1000; // in meters
    return distance; // Ensures the result is returned as a number
    // return distance;
  };

  useEffect(() => {
    const vehicleList = localStorage.getItem("vehicleList");
    if (vehicleList) {
      const parsedVehicleList = JSON.parse(vehicleList);
      setVehicles(parsedVehicleList || []);
    }
    const storedPickup = JSON.parse(localStorage.getItem("pickupCoordinates"));
    const storedDropoff = JSON.parse(
      localStorage.getItem("dropoffCoordinates")
    );

    if (storedPickup && storedDropoff) {
      setPickupCoordinates(storedPickup);
      setDropoffCoordinates(storedDropoff);
      const calculatedDistance = calculateDistance(storedPickup, storedDropoff);
      setDistance(calculatedDistance);
    }
  }, []);

  const handleSelectVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    console.log("Selected vehicle:", vehicle);
  };

  const handleCheckout = async () => {
    var message;
    console.log(typeof itemQuantity);
    if (!itemQuantity) {
      message = "Please Add Item Quantity.";
    }
    if (!selectedVehicle) {
      message = "please select vehicle first";
    }
    setLoading(true);

    if (message) {
      setError([message]);
      setLoading(false);
      return;
    }
    try {
      const payload = {
        city_id: "5b406b46d2ddf8062d11b788",
        user_id: user.user_id,
        is_round_trip: roundTrip,
        total_item_count: itemQuantity,
        is_user_drop_order: true,
        is_user_pickup_order: false,
        server_token: user.server_token,
        vehicle_id: selectedVehicle._id,
        total_distance: distance,
        total_time: 120,
        country_id: "5b3f76f2022985030cd3a437",
      };
      console.log(payload);
      const response = await axios.post(
        `${test_ip}api/user/get_courier_order_invoice`,
        payload
      );
      if (response.data.success) {
        localStorage.setItem(
          "courier_op",
          JSON.stringify(response.data.order_payment)
        );
        navigate("/courier/invocie");
      } else {
        var message = check_error_code(response.data.error_code);
        setError([message]);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      setError(["something went wrong"]);
    } finally {
      setLoading(false); // Set loading to false when the API call is complete
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.innerContainer}>
        <div style={styles.header}>
          <h2>Select a Vehicle</h2>
        </div>
        {vehicles.length === 0 ? (
          <p>No vehicles available.</p>
        ) : (
          <ul style={styles.vehicleList}>
            {vehicles.map((vehicle) => (
              <li
                key={vehicle._id}
                style={styles.vehicleItem}
                onClick={() => handleSelectVehicle(vehicle)}
              >
                <div
                  style={{
                    ...styles.vehicleInfo,
                    backgroundColor:
                      selectedVehicle?._id === vehicle._id ? "red" : "white",
                  }}
                >
                  <img
                    src={`${image_ip}${vehicle.image_url}`}
                    alt={vehicle.vehicle_name}
                    style={styles.vehicleImage}
                  />
                  <p
                    style={{
                      ...styles.vehicleName,
                      color:
                        selectedVehicle?._id === vehicle._id
                          ? "white"
                          : "black",
                      marginTop: "5px",
                    }}
                  >
                    {vehicle.vehicle_name}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        )}
        {/* <div style={styles.itemQuantityContainer}>
          <label htmlFor="item-quantity">Item Quantity </label>
          <input
            type="number"
            id="item-quantity"
            value={itemQuantity}
            onChange={(e) => setItemQuantity(e.target.value)}
            style={styles.itemQuantityInput}
          />
        </div> */}
        <div style={styles.itemQuantityContainer}>
          <label htmlFor="item-quantity">Item Quantity</label>
          <input
            type="number"
            id="item-quantity"
            value={itemQuantity}
            onChange={(e) => {
              const value = Math.max(1, parseInt(e.target.value, 10) || 1); // Ensure value is at least 1
              setItemQuantity(value);
            }}
            style={styles.itemQuantityInput}
            min="1" // Restricts the input to 1 and above in the UI
          />
        </div>

        <div style={styles.roundTripContainer}>
          <label style={styles.roundTripLabel}>Round Trip?</label>
          <div style={styles.roundTripOptions}>
            <label style={styles.radioLabel}>
              <input
                type="radio"
                checked={roundTrip === true}
                onChange={() => setRoundTrip(true)}
                style={{
                  ...styles.radioInput,
                  ...(roundTrip === true ? styles.radioInputChecked : {}),
                }}
              />
              Yes
            </label>
            <label style={styles.radioLabel}>
              <input
                type="radio"
                checked={roundTrip === false}
                onChange={() => setRoundTrip(false)}
                style={{
                  ...styles.radioInput,
                  ...(roundTrip === false ? styles.radioInputChecked : {}),
                }}
              />
              No
            </label>
          </div>
        </div>

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loading />
          </div>
        ) : (
          <button onClick={handleCheckout} style={styles.checkoutButton}>
            Checkout
          </button>
        )}

        {!error.length == 0 ? (
          <Alert style={{ margin: "10px" }} severity="error">
            {error[0]}
          </Alert>
        ) : null}
      </div>
    </div>
  );
};

// const styles = {
//   container: {
//     padding: "20px",
//     backgroundColor: "#f5f5f5",
//     height: "100vh",
//   },
//   innerContainer: {
//     maxWidth: "100%", // Make inner container take full width on smaller screens
//     margin: "0 auto",
//     backgroundColor: "white",
//     padding: "20px",
//     borderRadius: "10px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   header: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     marginBottom: "20px",
//   },
//   vehicleList: {
//     listStyleType: "none",
//     padding: "0",
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "start",
//   },
//   vehicleItem: {
//     marginBottom: "5px",
//     cursor: "pointer",
//     flex: "0 0 auto",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     marginRight: "5px",
//   },
//   vehicleInfo: {
//     borderRadius: "10px",
//     padding: "10px",
//     border: "1px solid #ccc",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "100px",
//     height: "100px",
//     marginBottom: "5px",
//     transition: "background-color 0.3s",
//     paddingLeft: "15px",
//     paddingRight: "15px",
//     margin: "0 auto",
//   },
//   vehicleImage: {
//     width: "70px",
//     height: "70px",
//     borderRadius: "50%",
//   },
//   vehicleName: {
//     marginTop: "10px",
//     fontWeight: "bold",
//     fontSize: "14px",
//     textAlign: "center",
//   },
//   itemQuantityContainer: {
//     marginBottom: "20px",
//   },
//   itemQuantityInput: {
//     padding: "10px",
//     width: "100px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//   },
//   roundTripContainer: {
//     marginBottom: "20px",
//   },
//   roundTripLabel: {
//     fontWeight: "bold",
//     marginRight: "10px",
//   },
//   roundTripOptions: {
//     display: "flex",
//     justifyContent: "space-between",
//     width: "100%",
//   },
//   radioLabel: {
//     fontSize: "14px",
//     display: "flex",
//     alignItems: "center",
//   },
//   radioInput: {
//     marginRight: "5px",
//   },
//   radioInputChecked: {
//     backgroundColor: "#ff6347",
//   },
//   checkoutButton: {
//     backgroundColor: "#ff6347",
//     color: "white",
//     padding: "12px 20px",
//     borderRadius: "8px",
//     width: "100%",
//     fontSize: "16px",
//     border: "none",
//     cursor: "pointer",
//   },
// };
const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f5f5f5",
    height: "100vh",
  },
  innerContainer: {
    maxWidth: "100%", // Make inner container take full width on smaller screens
    margin: "0 auto",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
  },
  vehicleList: {
    listStyleType: "none",
    padding: "0",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "start",
  },
  vehicleItem: {
    marginBottom: "5px",
    cursor: "pointer",
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "5px",
  },
  vehicleInfo: {
    borderRadius: "10px",
    padding: "10px",
    border: "1px solid #ccc",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    height: "100px",
    marginBottom: "5px",
    transition: "background-color 0.3s",
    paddingLeft: "15px",
    paddingRight: "15px",
    margin: "0 auto",
  },
  vehicleImage: {
    width: "70px",
    height: "70px",
    borderRadius: "100%",
  },
  vehicleName: {
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
  },
  itemQuantityContainer: {
    marginBottom: "20px",
  },
  itemQuantityInput: {
    padding: "10px",
    width: "100px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  roundTripContainer: {
    marginBottom: "20px",
  },
  roundTripLabel: {
    fontWeight: "bold",
    marginRight: "10px",
  },
  roundTripOptions: {
    display: "flex",
    flexDirection: "column", // This makes the radio buttons stack vertically
    justifyContent: "start",
    width: "100%",
  },
  radioLabel: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    marginBottom: "10px", // Add space between the options
  },
  radioInput: {
    marginRight: "5px",
  },
  radioInputChecked: {
    backgroundColor: "#ff6347",
  },
  checkoutButton: {
    backgroundColor: "red",
    color: "white",
    padding: "12px 20px",
    borderRadius: "10px",
    width: "100%",
    fontSize: "16px",
    border: "none",
    cursor: "pointer",
  },
};

export default SelectVehicle;
